import angular from 'angular';
import Model from './model';

import AnalyticsServ from '../services/analytics';

function FactFactory(Model, AnalyticsServ) {
  return class FactModel extends Model {
    constructor(data = {}) {
      super(data);
      this.setApi(
        '/case/:caseId/fact/:factId', {
          caseId: '@caseId',
          factId: '@id'
        }, {
          'create': {
            method: 'POST',
            success: [
              data => this.setData(data),
              data => AnalyticsServ.added('Fact')
            ]
          },
          'list': {
            method: 'GET',
            isArray: true
          },
          'query': {
            method: 'GET'
          },
          'update': {
            method: 'PUT',
            params: {
              factId: '@id'
            },
            success: [
              data => this.setData(data),
              data => AnalyticsServ.updated('Fact')
            ]
          },
          'addSource': {
            method: 'PUT',
            url: '/case/:caseId/fact/:factId/source/:sourceId'
          },
          'removeSource': {
            method: 'DELETE',
            url: '/case/:caseId/fact/:factId/source/:sourceId'
          },
          'addTag': {
            method: 'PUT',
            url: '/case/:caseId/fact/:factId/tag/:tagId'
          },
          'removeTag': {
            method: 'DELETE',
            url: '/case/:caseId/fact/:factId/tag/:tagId'
          },
          'delete': {
            method: 'DELETE',
            params: {
              factId: '@id'
            },
            success: [
              data => this.setData(data),
              data => AnalyticsServ.removed('Fact')
            ],
            headers: {
              'x-lynx-confirmationCode': () => {
                return this.getData().confirmationCode;
              },
              'x-lynx-revisionNumber': () => {
                return this.getData().revisionNumber;
              }
            },
            fail: [response => {
              this.data.confirmationCode = response.data.confirmationCode;
              // this.data.revisionNumber = response.data.revisionNumber;
              this.fail(response);
            }]
          }
        });
    }
  }
}
FactFactory.$inject = ['Model', 'AnalyticsServ'];

export default angular.module('models.fact', [Model, AnalyticsServ])
  .factory('Fact', FactFactory)
  .name;



// WEBPACK FOOTER //
// ./project/models/fact.js